import React from "react";
import DrawerAppBar from "./drawer";
import "./slider.css";
import pic2 from "./../../assets/images/pic1.jpg";
import pic1 from "./../../assets/images/pic7.jpg";
import pic3 from "./../../assets/images/pic10.jpg";
import pic4 from "./../../assets/images/pic3.jpg";
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
const Header = () => {
  let navigate = useNavigate();
  return (
    <Box className="header" sx={{ backgroundColor: "blue.main" }}>
      <DrawerAppBar />
      <Container className="hero-section">
        <Box sx={{ textAlign: "center", paddingY: "50px" }}>
          <Typography variant="h3" fontWeight={"bold"} color={"white.main"}>
            DISCOVER RARE, <br /> INNOVATE NEW.
          </Typography>
          <Box display={"flex"} justifyContent={"center"}>
            <Box width={"600px"} sx={{ lineHeight: "30px" }}>
              <p style={{ paddingTop: "1%", color: "#fff" }}>
                Looking for a new way to design your T-shirts? Our AI-powered
                platform offers endless possibilities for customization and
                creativity. Explore our site now!
              </p>
            </Box>
          </Box>

          <Button
            onClick={() => navigate("/generate")}
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: "yellow.light",
              color: "blue.main",
              "&:hover": {
                color: "yellow.light",
                background: "blue.main",
              },
              marginTop: "1%",
            }}
          >
            Create Now
          </Button>
          <Box>
            <section id="slider">
              <input type="radio" name="slider" id="s1" checked />
              <input type="radio" name="slider" id="s2" />
              <input type="radio" name="slider" id="s3" />
              <input type="radio" name="slider" id="s4" />
              <input type="radio" name="slider" id="s5" />

              <label for="s1" id="slide1">
                <img src={pic1} alt="" />
              </label>
              <label for="s2" id="slide2">
                <img src={pic2} alt="" />
              </label>
              <label for="s3" id="slide3">
                <img src={pic3} alt="" />
              </label>
              <label for="s4" id="slide4">
                <img src={pic4} alt="" />
              </label>
              <label for="s5" id="slide5">
                <img src={pic3} alt="" />
              </label>
            </section>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
